import type { Module } from 'vuex';
import store from '@/store';

/**
 * Idempotent Vuex module registration for the single root store.
 *
 * The root store has several entrypoints that each register a set of modules as an import
 * side-effect (`@/store/assets`, `@/store/users`, …) and the member SPA registers its
 * session modules at mount. Registering the same module twice makes Vuex run every action
 * handler (so `dispatch` resolves to an array), resets the module's state, and double-runs
 * mutations. Routing every registration through here guarantees a module is installed once.
 *
 * Modules are intentionally never unregistered here — these are session-shared / kept-alive.
 */
export const registerModuleOnce = (name: string, module: Module<unknown, unknown>): void => {
  if (!store.hasModule(name)) {
    store.registerModule(name, module);
  }
};

export const registerModulesOnce = (modules: Record<string, Module<unknown, unknown>>): void => {
  Object.entries(modules).forEach(([name, module]) => registerModuleOnce(name, module));
};
